import { For } from "solid-js";
import { CheckIcon, getCheckColor } from "./check_icon";
import { useDenominationGridContext } from "../context/denomination_grid_context";

export function Variants() {
  const {
    setCustomSelected,
    denominationBorderClass,
    externalProps,
    internalState,
  } = useDenominationGridContext();

  const { brand, isDarkTheme } = externalProps;

  const {
    selectedAmount,
    setSelectedVariantId,
    setSelectedAmount,
    dryRunErrorMessage: errorMessage,
  } = internalState;

  return (
    <For each={brand.variantDetailedResponse}>
      {(variant) => {
        let amount = variant.amount;
        let vairantId = variant.variantId;

        const isSelectedAmount = () => selectedAmount() == amount;

        return (
          <div
            class={`${denominationBorderClass}`}
            classList={{
              "border-neutral-700 dark:border-baseTertiaryLight":
                isSelectedAmount() && errorMessage() === null,
              "border-neutral-200": !isSelectedAmount(),
              "border-2": isSelectedAmount(),
              border: !isSelectedAmount(),
              "bg-slate-100": isSelectedAmount(),
              "bg-baseTertiaryLight": !isSelectedAmount(),
              "border-errorDark hover:border-errorDark":
                isSelectedAmount() && errorMessage() != null,
            }}
            onClick={() => {
              setSelectedVariantId(vairantId);
              setCustomSelected(false);
              setSelectedAmount(amount);
            }}
          >
            <div class="w-full text-bold">
              <span>{variant.text}</span>
            </div>
            {/*TODO - amount should be lighter when variants are on*/}
            <div class="text-bold">
              <span>₹{amount}</span>
            </div>
            <div class="mr-3"></div>
            <div
              class="absolute right-[9px] top-[1px] h-[6px] w-[9px]"
              classList={{
                "group-hover:block": !isSelectedAmount(),
                block: isSelectedAmount(),
                hidden: !isSelectedAmount(),
                [getCheckColor({
                  isSelected: isSelectedAmount(),
                  isDarkTheme: isDarkTheme ?? false,
                })]: true,
              }}
            >
              <CheckIcon />
            </div>
          </div>
        );
      }}
    </For>
  );
}
